"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPInternalTicketWorkflowQuery = exports.SAPInternalTicketQuery = exports.SAPInternalTicketUpdate = exports.SAPInternalTicketCreate = exports.SAPInternalTicketTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const profile_1 = require("../../profile");
const enums_1 = require("../common/enums");
const tag_1 = require("../common/tag");
const visibility_1 = require("../common/visibility");
exports.SAPInternalTicketTransport = typebox_1.Type.Recursive((Self) => typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    note: typebox_1.Type.String(),
    entityID: typebox_1.Type.String({ minLength: 1 }),
    entityType: enums_1.SourgumInternalTicketRelatedEntity,
    issueCausedByProfileID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    monetaryLoss: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    status: typebox_1.Type.Optional(enums_1.InternalTicketStatus),
    deletedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    assignedToProfileID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    assignedTeam: typebox_1.Type.Optional(profile_1.SourgumTeam),
    replyToID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    tags: typebox_1.Type.Array(tag_1.TagTransport),
    replies: typebox_1.Type.Array(Self), // Use Self to refer to the recursive type
    archivedDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    dueDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' }))),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    visibility: typebox_1.Type.Array(visibility_1.VisibilityTransport),
    isPinned: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    metadata: common_1.MetaData,
}), { $id: 'SAPInternalTicketTransport' });
exports.SAPInternalTicketCreate = typebox_1.Type.Intersect([
    // Required fields
    typebox_1.Type.Object({
        note: typebox_1.Type.String(),
        entityID: typebox_1.Type.String({ minLength: 1 }),
        entityType: enums_1.SourgumInternalTicketRelatedEntity,
        tags: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    }),
    // Optional fields
    typebox_1.Type.Partial(typebox_1.Type.Object({
        replyToID: typebox_1.Type.String({ format: 'uuid' }),
        issueCausedByProfileID: typebox_1.Type.String({ format: 'uuid' }),
        monetaryLoss: typebox_1.Type.Integer(),
        status: enums_1.InternalTicketStatus,
        assignedToProfileID: typebox_1.Type.String({ format: 'uuid' }),
        assignedTeam: profile_1.SourgumTeam,
        dueDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
        images: typebox_1.Type.Array(common_1.S3ItemReference),
        visibility: typebox_1.Type.Array(typebox_1.Type.String()),
        isPinned: typebox_1.Type.Boolean(),
        followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    })),
]);
exports.SAPInternalTicketUpdate = typebox_1.Type.Partial(typebox_1.Type.Object({
    monetaryLoss: typebox_1.Type.Integer(),
    issueCausedByProfileID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    status: (0, common_1.Nullable)(enums_1.InternalTicketStatus),
    assignedTeam: (0, common_1.Nullable)(profile_1.SourgumTeam),
    assignedToProfileID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    tags: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    archivedDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
    dueDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    visibility: typebox_1.Type.Array(typebox_1.Type.String()),
    isPinned: typebox_1.Type.Boolean(),
    followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
}));
exports.SAPInternalTicketQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        /**
         * Needs to be a comma separated list of entity ids. Use [].join(',')
         */
        entityID: typebox_1.Type.String({ minLength: 1 }),
        entityType: enums_1.SourgumInternalTicketRelatedEntity,
        issueCausedByProfileID: typebox_1.Type.String({ format: 'uuid' }),
        /**
         * Either pass an array of actual InternalTicketStatus OR true for things with a status OR false with things with no status
         * Needs to be a comma separated list of type InternalTicketStatus. Use [].join(',')
         */
        status: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ minLength: 1 })]),
        /**
         * Needs to be a comma separated list of profile ids. Use [].join(',')
         */
        assignedToProfileID: typebox_1.Type.String({ minLength: 1 }),
        /**
         * Needs to be a comma separated list of type SourgumTeam. Use [].join(',')
         */
        assignedTeam: typebox_1.Type.String({ minLength: 1 }),
        replyToID: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ format: 'uuid' })]),
        /**
         * Needs to be a comma separated list of tag ids. Use [].join(',')
         */
        tags: typebox_1.Type.String({ minLength: 1 }),
        createdBefore: typebox_1.Type.String({ format: 'date-time' }),
        createdAfter: typebox_1.Type.String({ format: 'date-time' }),
        dueDateBefore: typebox_1.Type.String({ format: 'date-time' }),
        dueDateAfter: typebox_1.Type.String({ format: 'date-time' }),
        /**
         * Pass up false if you only want non deleted notes
         */
        includeDeleted: typebox_1.Type.Boolean(),
        createdByProfileID: typebox_1.Type.String({ format: 'uuid' }),
        /**
         * Needs to be a comma separated list of profile ids. Use [].join(',')
         */
        followerIDs: typebox_1.Type.String({ minLength: 1 }),
        includeReplies: typebox_1.Type.Boolean(),
    }),
]));
exports.SAPInternalTicketWorkflowQuery = typebox_1.Type.Object({
    OPEN: typebox_1.Type.Intersect([typebox_1.Type.Omit(exports.SAPInternalTicketQuery, ['status']), typebox_1.Type.Object({ status: typebox_1.Type.Literal('OPEN') })]),
    IN_PROGRESS: typebox_1.Type.Intersect([
        typebox_1.Type.Omit(exports.SAPInternalTicketQuery, ['status']),
        typebox_1.Type.Object({ status: typebox_1.Type.Literal('IN_PROGRESS') }),
    ]),
    SOLVED: typebox_1.Type.Intersect([
        typebox_1.Type.Omit(exports.SAPInternalTicketQuery, ['status']),
        typebox_1.Type.Object({ status: typebox_1.Type.Literal('SOLVED') }),
    ]),
});
//# sourceMappingURL=internal-ticket.js.map